import { Route } from "react-router-dom";

import HomeView from "./views/HomeView";
import PreambleView from "./views/PreambleView";
import QuizQuestionsView from "./views/QuizQuestionsView";
import EmailView from "./views/EmailView";
import QuizResultsView from "./views/QuizResultsView";
import CalculatorView from "./views/CalculatorView";
import CarRegView from "./views/CarRegView";
import RegResultsView from "./views/RegResultsView";
import LoanLengthView from "./views/LoanLengthView";
import PersonalDetailsView from "./views/PersonalDetailsView";
import HouseholdDetailsView from "./views/HouseholdDetailsView";
import EmploymentDetailsView from "./views/EmploymentDetailsView";
import LoadingView from "./views/LoadingView";
import ResultsMoreDetailsView from "./views/ResultsMoreDetailsView";

import BudgetView from "./views/BudgetView";
import DepositView from "./views/DepositView";
import MileageView from "./views/MileageView";
import ResultsView from "./views/ResultsView";
import QuickDetailsView from "./views/QuickDetailsView";
import FinancialGuideView from "./views/FinancialGuideView";
import HirePurchaseGuideView from "./views/HirePurchaseGuideView";
import PcpGuideView from "./views/PcpGuideView";
import PersonalLoanGuideView from "./views/PersonalLoanGuideView";
import LeaseGuideView from "./views/LeaseGuideView";

function Routes() {
  return (
    <>
      {/*Guides*/}
      <Route path="/financial-guide/lease" component={LeaseGuideView} />
      <Route
        path="/financial-guide/personal-loan"
        component={PersonalLoanGuideView}
      />
      <Route path="/financial-guide/pcp" component={PcpGuideView} />
      <Route
        path="/financial-guide/hire-purchase"
        component={HirePurchaseGuideView}
      />
      <Route exact path="/financial-guide" component={FinancialGuideView} />

      {/*Journey*/}
      <Route
        path="/more-details/:id/:carReg/:carPrice/:depositValue?/:carMileage/:budget/:loanLength/:firstName/:totalAmount/:monthlyPayment/:interest/:balloon?"
        component={ResultsMoreDetailsView}
      />
      <Route
        path="/results/:carReg/:carPrice/:depositValue?/:carMileage/:budget/:loanLength/:firstName"
        component={ResultsView}
      />
      <Route
        path="/loading/:carReg/:carPrice/:depositValue?/:carMileage/:budget/:loanLength/:firstName"
        component={LoadingView}
      />
      <Route
        path="/employment-details/:carReg/:carPrice/:depositValue?/:carMileage/:budget/:loanLength/:firstName"
        component={EmploymentDetailsView}
      />
      <Route
        path="/household-details/:carReg/:carPrice/:depositValue?/:carMileage/:budget/:loanLength/:firstName"
        component={HouseholdDetailsView}
      />
      <Route
        path="/personal-details/:fName/:lName/:carReg/:carPrice/:depositValue?/:carMileage/:budget/:loanLength"
        component={PersonalDetailsView}
      />
      <Route
        path="/loan-length/:fName/:lName/:carReg/:carPrice/:depositValue?/:carMileage/:budget"
        component={LoanLengthView}
      />
      <Route
        path="/budget/:fName/:lName/:carReg/:carPrice/:depositValue?/:carMileage"
        component={BudgetView}
      />
      <Route
        path="/mileage/:fName/:lName/:carReg/:carPrice/:depositValue?"
        component={MileageView}
      />
      <Route
        path="/deposit/:fName/:lName/:carReg/:carPrice"
        component={DepositView}
      />
      <Route
        path="/reg-results/:fName/:lName/:carReg"
        component={RegResultsView}
      />
      <Route path="/car-reg/:fName/:lName" component={CarRegView} />
      <Route path="/calculator/:fName?/:lName?/" component={CalculatorView} />
      <Route path="/quiz-results/:fName/:lName" component={QuizResultsView} />
      <Route path="/email" component={EmailView} />
      <Route
        path="/quiz-questions/:qNumber/:fName/:lName"
        component={QuizQuestionsView}
      />
      <Route path="/quick-details" component={QuickDetailsView} />
      <Route path="/preamble" component={PreambleView} />
      <Route exact path="/" component={HomeView} />
    </>
  );
}

export default Routes;
